import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=8174b508&scoped=true&"
import script from "./Invite.vue?vue&type=script&lang=js&"
export * from "./Invite.vue?vue&type=script&lang=js&"
import style0 from "styles/views/index/invite.css?vue&type=style&index=0&id=8174b508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8174b508",
  null
  
)

export default component.exports